export default "__VITE_ASSET__ezgVfsMl__"